import React from 'react'
import { Link } from 'react-router-dom'
import CountUp from 'react-countup';
import abImg from '../../images/aboutbanner2.webp'


const About3 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-left-image">
                            <div className="image">
                                <img src={abImg} alt="" />
                            </div>
                            {/* <div className="experience">
                                <h2><span className="text-musk-title" ><CountUp end={20} enableScrollSpy /></span></h2>
                               
                                <h3>Years <span>Experience</span></h3>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="content">
                            <div className="text">
                                <h2>About Company</h2>
                                <h3>Kihi Enterprises</h3>
                                <p>
                                    Established in the year 2020 at Pai Nagar, Borivali (West), Mumbai, Maharashtra We “Kihi
                                    Enterprises” are a Sole Proprietorship based firm, engaged as the foremost Wholesaler of Earth Pit
                                    Cover, Earthing Electrode, Copper Lightning Arrester, Earthing Copper Stripand many more.
                                </p>
                            </div>
                            <div className="list">
                                <ul>
                                    <li><i className="ti-check"></i> <span>Raw Materials</span></li>
                                    <li><i className="ti-check"></i> <span>Quality Control</span></li>
                                    <li><i className="ti-check"></i> <span>Finished Goods</span></li>
                                </ul>
                               
                            </div>
                            <div className="about-btn">
                                <Link onClick={ClickHandler} to="/about" className="theme-btn">About Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About3;